import { IAttrValue } from "@multiweb/types/contracts";
import { PromiseUtils } from "../../../../../../../Global/Base/Promises/PromiseUtils";
import { AttrValueReader } from "../../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { OWObject } from "../../../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IValidatable } from "../../../../../../UI.BaseControls/ControlInterfaces";
import { GenericControl } from "../../../../../../UI.BaseControls/GenericControl";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { EditItemTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/EditItemTemplate";
import { IEditItemTemplateMasterRef } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/ITemplate";
import { ElementUtils } from "../../../../../../UI.ElementarControls/Helpers/ElementUtils";
import { IHTMLElementWithControl } from "../../../../Controls/ControlInterfaces";
import { FileEdit } from "../../../../Controls/FileEdit";
import { FileColumn } from "../FileColumn";
import { IMasterObjectRequestDetail } from "../LOVColumn";

export class FileEditTemplate extends EditItemTemplate implements IEditItemTemplateMasterRef {
    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const data = this._getDataFromSet(dataSet);

        const editableControl = document.createElement("div");
        editableControl.setAttribute("data-attrname", this.parentColumn.attrName);
        editableControl.setAttribute("data-filemask", (this.parentColumn as FileColumn).fileMask);
        if (this.parentColumn.hasAttribute("data-allowsignwithoutedit"))
            editableControl.setAttribute("data-allowsignwithoutedit", this.parentColumn.getAttribute("data-allowsignwithoutedit"));
        if (this.parentColumn.hasAttribute("data-allowcountersignature"))
            editableControl.setAttribute("data-allowcountersignature", this.parentColumn.getAttribute("data-allowcountersignature"));

        const fileEdit = new FileEdit({ element: editableControl, originalRightsDefinition: this.parentColumn.originalRightsDefinition });
        fileEdit.enabledVisual = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva

        fileEdit.dataType = column.dataType;
        // data se nastaví až v odpovědi na událost masterObjectRequest - a rovnou se nastaví i správný stav při probíhajícím uploadu a neproblikává možnost stáhnout soubor
        //fileEdit.controlValue = data;
        fileEdit.isEditing = true;

        // v dalším ticku, až bude element v DOMu, aby šlo hledat rodiče
        PromiseUtils.delay(0).then(() => {
            const id = GenericControl.findParent(editableControl, (el) => el.classList.contains("DataRow")).getAttribute("datakey");
            ElementUtils.callEvent(column as HTMLElement, "masterObjectRequest", {
                control: fileEdit,
                objectId: id != null ? id : "",
                data: AttrValueReader.read(data),
            } as IMasterObjectRequestDetail, true, true);
        });

        fileEdit.valueChanged.add(() => {
            ElementUtils.callEvent(parentItem, "valuechanged", { value: fileEdit.controlValue, column: column });
        });
        return { element: fileEdit.element, validatableControl: fileEdit };
    }

    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        const fileEdit = (item as IHTMLElementWithControl).tscControl as FileEdit;

        fileEdit.controlValue = AttrValueReader.read(this._getDataFromSet(dataSet));
    }

    /**
     * Aktualizuje instanci objektu
     * @param obj nový objekt
     * @param item HTML element reprentující buňku sloupce
     */
    public setInstance(obj: OWObject, item: HTMLElement): void {
        const fileEdit = (item as IHTMLElementWithControl).tscControl as FileEdit;
        fileEdit.actualObject = obj;
    }
}
